<nav class="sb-sidenav accordion bg-green" id="sidenavAccordion">
    <button class="minimize-btn"  (click)="toggleSidebar()">
        <i *ngIf="checkSidebarIsToggled() == false" class="fa fa-angle-left" aria-hidden="true"></i>
        <i *ngIf="checkSidebarIsToggled() == true" class="fa fa-angle-right"  aria-hidden="true"></i>
    </button>
    
    <div class="sb-sidenav-menu">
        <div class="nav bd_adminmenu">
            <ng-container *ngFor="let item of navItems">
                <a class="nav_link" routerLinkActive="active" [routerLink]="item.link">
                    <div class="nav_icon">
                        <img src="{{ item.icon }}">
                        <img src="{{ item.iconhover }}" class="acicon">
                    </div>
                    <span>{{item.label}}</span>
                </a>
            </ng-container>
        </div>
    </div>
    <div class="sb-sidenav-footer">
        © {{ date.getUTCFullYear() }} <a routerLink="/" class="text-white">Tea Inntech</a>.
    </div>
</nav>